(function installBearWoodsShipAidCart() {
  if (window.__bearWoodsShipAidCart) {
    window.__bearWoodsShipAidCart.reconcile();
    return;
  }

  const script = document.currentScript;
  const currency = script?.dataset.currency || window.Shopify?.currency?.active || 'USD';
  const language = script?.dataset.lang || window.Shopify?.locale || 'en';
  let widget = null;
  let parking = null;
  let timer = null;
  let lastCartSignature = '';
  let autoOptInConfig = null;
  let cartSyncInProgress = false;
  let cartSyncAgain = false;
  let observedCartRoot = null;
  const cartObserver = new MutationObserver(schedule);
  const cartRootObserver = new MutationObserver(function (records) {
    if (observedCartRoot?.isConnected) return;
    const selector = window.theme?.pageType === 'cart' ? '[data-section-type="cart"]' : '#mini-cart';
    if (observedCartRoot || records.some(record => Array.from(record.addedNodes).some(node =>
      node instanceof Element && (node.matches(selector) || node.querySelector(selector))))) schedule();
  });

  function observeCart() {
    const cart = window.theme?.pageType === 'cart'
      ? document.querySelector('[data-section-type="cart"]')
      : document.getElementById('mini-cart');
    // Warehouse replaces cart contents inside these stable ancestors.
    const root = cart?.closest('.header__action-item--cart, [id^="shopify-section-"]') || cart?.parentElement || cart;
    if (root === observedCartRoot) return;
    cartObserver.disconnect();
    observedCartRoot = root;
    if (root) cartObserver.observe(root, { childList: true, subtree: true });
  }

  function reconcile() {
    observeCart();
    if (!document.body || !customElements.get('shipaid-widget')) return;
    if (!widget) {
      widget = document.createElement('shipaid-widget');
      widget.setAttribute('data-bear-woods-shipaid', '');
      widget.setAttribute('disableRefresh', '');
      widget.setAttribute('currency', currency);
      widget.setAttribute('lang', language);
      widget.style.cssText = 'display:block;width:100%;margin:0 0 12px;' +
        '--shipaid-font:var(--text-font-family, sans-serif);' +
        '--shipaid-font-lg:calc(var(--base-text-font-size, 20px) - 1px);' +
        '--shipaid-font-heavy:var(--text-font-bolder-weight, 600);' +
        '--shipaid-font-xxs:14px;' +
        '--shipaid-prompt-actions-price-fontSize:var(--shipaid-font-lg);' +
        '--shipaid-prompt-actions-price-color:#671113;' +
        '--shipaid-toggle-active:#671113;';
      widget.addEventListener('click', onProtectionChoice, true);
      widget.addEventListener('shipaid:widget:loaded', function (event) {
        if (event.target !== widget) return;
        autoOptInConfig = event.detail;
        synchronizeCart();
      });
    }

    const checkout = window.theme?.pageType === 'cart'
      ? document.querySelector('[data-section-type="cart"] .cart-recap__checkout')
      : document.querySelector('#mini-cart .mini-cart__button-container');
    if (checkout) {
      if (widget.nextElementSibling !== checkout) checkout.before(widget);
      styleWidget();
      return;
    }

    // Keep one instance alive so its cart cleanup can run while the cart is empty.
    if (!parking || !parking.isConnected) {
      parking = document.createElement('div');
      parking.hidden = true;
      parking.setAttribute('data-bear-woods-shipaid-parking', '');
      document.body.append(parking);
    }
    if (widget.parentElement !== parking) parking.append(widget);
    styleWidget();
  }

  function styleWidget() {
    const root = widget.shadowRoot;
    if (!root || root.querySelector('[data-bear-woods-shipaid-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-bear-woods-shipaid-style', '');
    style.textContent = `
      :host .shipaid-prompt .prompt-product .prompt-product-actions {
        flex-direction: row;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;
      }
      :host .prompt-product-actions-price { white-space: nowrap; }
      :host .prompt-product-actions .shipaid-checkbox {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex: 0 0 24px;
        width: 24px;
        height: 24px;
      }
      :host .prompt-product-actions .shipaid-checkMark {
        position: relative;
        top: auto;
        right: auto;
        display: block;
        margin: 0;
      }
      :host .prompt-product-details { min-width: 0; }
    `;
    // Prepend outside Lit's render range so updates retain the same scoped style.
    root.prepend(style);
  }

  function schedule() {
    if (timer !== null) return;
    timer = setTimeout(function () {
      timer = null;
      reconcile();
    }, 0);
  }

  function onProtectionChoice(event) {
    const input = event.composedPath().find(node => node instanceof HTMLInputElement && node.type === 'checkbox');
    if (!input || input.getRootNode() !== widget.shadowRoot
      || !input.closest('.shipaid-checkbox, .shipaid-toggle')) return;
    // Persist the shopper's choice before V1 performs its normal add/remove action.
    if (typeof widget.setOptOutByCustomer === 'function') widget.setOptOutByCustomer(!input.checked);
  }

  function onShipAidCartUpdated(event) {
    if (event.detail?.data?.source !== 'shipaid-widget') return;
    const cart = event.detail?.cart;
    if (!cart || !Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) return;
    const signature = JSON.stringify({
      items: cart.items.map(item => [item.key, item.quantity, item.final_line_price]),
      total: cart.total_price
    });
    if (signature === lastCartSignature) return;
    lastCartSignature = signature;
    // Warehouse owns the cart lines, total and item count; ask its native renderer.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    schedule();
  }

  function onCartRerendered() {
    reconcile();
    synchronizeCart();
  }

  async function synchronizeCart() {
    if (!widget || typeof widget.updateCart !== 'function') return;
    if (cartSyncInProgress) { cartSyncAgain = true; return; }
    cartSyncInProgress = true;
    try {
      do {
        cartSyncAgain = false;
        await widget.updateCart();
        if (!autoOptInConfig?.planActive || !autoOptInConfig.widgetAutoOptIn || !autoOptInConfig.widgetShowCart) continue;
        if (widget.customerId && autoOptInConfig.excludedCustomersIdsAutoOptIn?.includes(
          'gid://shopify/Customer/' + widget.customerId)) continue;
        // The public quote methods honor product exclusions and prepare the correct fee variant.
        if (typeof widget.updateProtection !== 'function' || typeof widget.calculateProtectionTotal !== 'function'
          || typeof widget.attemptAddProtection !== 'function') continue;
        await widget.updateProtection();
        if (widget.hasProtection?.() || widget.getIsOptOutByCustomer?.()) continue;
        if (!(await widget.calculateProtectionTotal() > 0)) continue;
        // Reuse V1's opt-out, existing-protection and auto-opt-in guards after native cart changes.
        await widget.attemptAddProtection();
      } while (cartSyncAgain);
    } catch {} finally {
      cartSyncInProgress = false;
    }
  }

  function onExternalCartUpdate(event) {
    if (event.detail?.data?.source === 'shipaid-widget') onShipAidCartUpdated(event);
  }

  window.__bearWoodsShipAidCart = { reconcile: schedule };
  document.addEventListener('shipaid:cart:updated', onShipAidCartUpdated);
  // V1's automatic fee variant correction emits cart:update rather than the named event.
  document.addEventListener('cart:update', onExternalCartUpdate);
  window.addEventListener('cart:update', onExternalCartUpdate);
  // Warehouse's mini-cart event does not bubble, so capture it at document level.
  document.addEventListener('cart:rerendered', onCartRerendered, true);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);

  function start() {
    observeCart();
    // A cheap connectivity guard catches third-party ancestor replacements without scanning page changes.
    cartRootObserver.observe(document.documentElement, { childList: true, subtree: true });
    customElements.whenDefined('shipaid-widget').then(schedule);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
